import type { PageTour } from '../types';

export const workLocationTour: PageTour = {
  id: 'work-location',
  label: 'Work Location Tour',
  steps: [
    {
      target: '[data-tour="work-location-header"]',
      title: 'Work Location',
      content: 'Declare where you\'re working each day — office, home, or another location.',
    },
    {
      target: '[data-tour="work-location-declare"]',
      title: 'Declare Location',
      content: 'Select your work location for today or upcoming days. Your team can see where you\'ll be.',
    },
    {
      target: '[data-tour="work-location-calendar"]',
      title: 'Location Calendar',
      content: 'View your declared work locations on the calendar. See your team\'s locations at a glance.',
    },
  ],
};
